import React from 'react';
import styles from './task.module.scss';
import CustomButton, { ButtonType } from '../common/buttons/CustomButton';
import copies from '../../copies.json';
import { FormattedMessage } from "react-intl";

const taskCopies = copies.insights.tasks.firstMember;

const FirstMemberTask = ({ onClickHandle, done }) => {
    return (
        <div className={styles.container}>
            {done && <div className={styles.doneContainer}/>}
            <div className={styles.header}>
                <span className={styles.title}>
                    {taskCopies.title}
                    {done && (
                        <span className={styles.done}>
                            <img src='/assets/img/steps3Images/insights/done.svg'/>
                            {copies.insights.tasks.done}
                        </span>
                    )}
                </span>
                <span className={styles.description}>
                    <FormattedMessage id='insights.tasks.firstMember.description'/>
                </span>
            </div>
            <div className={styles.footer}>
                {!done && (
                    <CustomButton onClick={onClickHandle} className={styles.handleButton} type={ButtonType.PRIMARY_BLUE}>
                        {taskCopies.CTA}
                    </CustomButton>
                )}
            </div>
        </div>
    );
};

export default FirstMemberTask;
